import { Pipe, PipeTransform } from '@angular/core';
import { ToutesLettresMajusculePipe } from './toutes-lettres-majuscule.pipe';
import { PremiereLettreMajusculePipe } from './premiere-lettre-majuscule.pipe';

@Pipe({
	standalone: true,
	name: 'nomPrenom'
})
export class NomPrenomPipe implements PipeTransform {

	constructor(private toutesLettresMajusculePipe: ToutesLettresMajusculePipe,
				private premiereLettreMajusculePipe: PremiereLettreMajusculePipe) {
	}

	transform(value: any): string {
		if (!value || value.nom === undefined) {
			return '';
		}
		return this.toutesLettresMajusculePipe.transform(value.nom) + ' ' + this.premiereLettreMajusculePipe.transform(value.prenom);
	}

}
